(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CFP-Main-Content-Section"] && !Shopify.designMode) return;
  try {
    

var productsUrl = '{{ collection.url }}/products.json';
var productIndex = [];
var colorFilter = false;
var colors = [];

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.loadFirst').forEach(function (el) {
    el.style.display = 'block';
  });

  document.querySelectorAll('.overstock-collection').forEach(function (el) {
    el.style.display = 'block';
  });

  document.querySelectorAll('.overstock-group p').forEach(function (el) {
    if (el.classList.contains('no-product')) {
      var parent = el.closest('.overstock-group');
      if (parent) {
        parent.style.display = 'none';
      }
    }
  });

  document.querySelectorAll('.hover-popup').forEach(function (el) {
    el.style.display = 'block';
  });

  // Change product variant when color swatch is clicked
  document.querySelectorAll('.cfp-variantion-color-box-parent > div').forEach(function (el) {
    el.addEventListener('click', function () {
      var newSelectedVariantId = this.id.replace('select-', '');
      var oldVariantId = this.dataset.first;
      var newPriceSelected = this.dataset.price;

      document.querySelectorAll('.color-box').forEach(function (box) {
        box.style.border = '1px solid #1C355E';
      });

      var selectedBox = document.getElementById('select-' + newSelectedVariantId);
      if (selectedBox) {
        selectedBox.style.border = '2px solid #AA2D29';
      }

      var variantInput = document.getElementById(oldVariantId);
      if (variantInput) {
        variantInput.value = newSelectedVariantId;
      }

      var priceElement = document.getElementById('price-' + oldVariantId);
      if (priceElement) {
        priceElement.innerHTML = newPriceSelected;
      }

      var detailsButton = document.getElementById('variant-' + oldVariantId);
      if (detailsButton) {
        detailsButton.dataset.variant = newSelectedVariantId;
      }
    });
  });

  // Details button redirects to product page
  document.querySelectorAll('.details-cfp-btn').forEach(function (el) {
    el.addEventListener('click', function () {
      var collectionUrlBase = this.dataset.collection;
      var productUrlBase = this.dataset.product;
      var productVariationString = this.dataset.variant;

      setTimeout(function () {
        window.location =
          '/collections/' +
          collectionUrlBase +
          '/products/' +
          productUrlBase +
          '?variant=' +
          productVariationString;
      }, 10);
    });
  });

  // Buy button redirects to cart
  document.querySelectorAll('.buy-cfp-btn').forEach(function (el) {
    el.addEventListener('click', function () {
      setTimeout(function () {
        window.location = '/cart';
      }, 600);
    });
  });

  var items = [];

  function add(item) {
    Shopify.addItem(item.id, item.quantity, function () {
      if (items.length > 0) {
        add(items.shift());
      } else {
        window.location = '/cart';
      }
    });
  }

  function isVisible(el) {
    return !!(
      el.offsetWidth ||
      el.offsetHeight ||
      el.getClientRects().length
    );
  }

  function addToCart(element) {
    items = [];

    document.querySelectorAll('[data-variant-id]').forEach(function (el) {
      if (!isVisible(el)) {
        return;
      }

      var quantityInput = el.querySelector('input.quantity');

      if (quantityInput && parseInt(quantityInput.value, 10) > 0) {
        items.push({
          id: el.dataset.variantId,
          quantity: parseInt(quantityInput.value, 10)
        });
      }
    });

    if (items.length > 0) {
      if (element) {
        element.innerHTML = 'Redirecting to Cart';
        element.disabled = true;
      }

      add(items.shift());
    } else {
      window.location = '/cart';
    }
  }

  // If addToCart is called from HTML such as onclick="addToCart(this)",
  // expose it globally.
  window.addToCart = addToCart;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function() {    
   $('.media > img').each(function() {
    if ( $(this).attr('src') == '//americanvinylworks.com/cdn/shop/files/drawmyfence.png?v=1691006068&width=3200' ) {
      $(this).parent().wrap('<a href="/pages/draw-my-fence"></a>');
    };
   });
 });   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-center-selector"] && !Shopify.designMode) return;
  try {
    

    $(document).ready(function() {

    $(".quote-center-padding").parent().css({"border-bottom": "1px solid black", "border-top": "1px solid black"});
      
    // var url      = window.location.href; 
    // if (url == "https://americanvinylworks.com/") {
    //     console.log("home page");
    //     $(".quote-center-padding").attr("style", "display:block;");
    //     $(".quote-center-padding").data("display", "show");
    //     $("#Details-HeaderMenu-1").prop('open', 'true');
    // };    
    
    // // show and hides quote center on click
    // $("#HeaderMenu-quote-center").on("click", function() {
    //   if ($(".quote-center-padding").data("display") == "hide") { 
    //     $(".quote-center-padding").attr("style", "display:block;");
    //     $(".quote-center-padding").data("display", "show");
    //     // $("#Details-HeaderMenu-1").prop('open', 'true');
    //     //console.log('from hide to show');
    //   } 
    //   else 
    //   {  
    //     $(".quote-center-padding").attr("style", "display:none;");
    //     $(".quote-center-padding").data("display", "hide");
    //     // $("#Details-HeaderMenu-1").prop('open', 'false');
    //     //console.log('from show to hide');
    //     return;
    //   };
    // }); 

    // // keeps quote center carrot in correct position if open
    // $(".header__menu-item").on("click", function() {
    //   if ($(this).parent().attr('id') != "Details-HeaderMenu-1") {
    //     //console.log('not quote center');
    //     if ($(".quote-center-padding").data("display",) == "show") {
    //       $("#Details-HeaderMenu-1").prop('open', 'true');
    //     };
    //   };
    // });  
    
  });


  } catch(e) { console.error(e); }
})();
})();
